<h2 mat-dialog-title>{{ isEditMode ? 'Edit Vulnerability Profile' : 'Add New Vulnerability Profile' }}</h2>

<mat-dialog-content>
    <div class="profile-name-display" *ngIf="isEditMode">
        <label>Vulnerability Profile Type:</label>
        <span>{{ editingProfile.vulnerabilityType }}</span>
    </div>
    <div class="profile-name-input" *ngIf="!isEditMode">
        <label>Vulnerability Profile Type:</label>
        <input 
            type="text" 
            class="profile-type-input-field"
            [(ngModel)]="editingProfile.vulnerabilityType"
            placeholder="Enter vulnerability profile type"
        />
    </div>
    
    <div class="overlay-inputs-grid">
        <div class="overlay-input-item" *ngFor="let indicator of indicators">
            <label class="overlay-input-label">{{ indicator.name }} ({{ indicator.code }})</label>
            <input
                type="number"
                class="overlay-input-field"
                [(ngModel)]="editingProfile[indicator.code]"
                [readonly]="isNotApplicable"
                [class.readonly-input]="isNotApplicable"
                placeholder="Enter value"
            />
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button (click)="cancel()" class="dialog-button cancel-button" [disabled]="submitted">Cancel</button>
    <button mat-flat-button color="accent" (click)="save()" class="dialog-button save-button" [disabled]="submitted">
        {{ submitted ? 'Saving...' : 'Submit' }}
    </button>
</mat-dialog-actions>
